/**
 * Default fieldsAndLabelsToRender object in the case that stats does not come back with one
 * Currently, designed for Burlingame
 *
 * TODO: Some values will come in that are nice for the database,
 *  but not nice for us. This means that we'll need a dictionary
 *  for each of these pieces of information to make the display
 *  value nice to reader.
 *
 *  List of possible pieces that will need this "MapRenderer":
 *    propertyInfo.rentalType
 *    certificateInfo.registrantType
 */
export const defaultGenericFieldsAndLabelsToRender = [
  // This is config v0
  [
    [
      {
        data: [
          { label: 'Parcel Number', dataKey: 'propertyInfo.parcelNumber' },
          {
            label: 'Property Address',
            dataKey: 'propertyInfo.propertyAddress',
          },
          { label: 'Number of Parking', dataKey: 'propertyInfo.numVehicles' },
        ],
      },
      {
        data: [
          {
            label: 'Application Date',
            dataKey: 'certificateInfo.applicationDate',
          },
          {
            label: 'Business License',
            dataKey: 'certificateInfo.businessLicense',
          },
          {
            label: 'Permit Holder',
            dataKey: 'certificateInfo.certificateHolder',
          },
          {
            label: 'Permit Holder Email',
            dataKey: 'certificateInfo.certificateHolderEmail',
          },
          {
            label: 'Permit Holder Type',
            dataKey: 'certificateInfo.registrantType',
            component: 'MapRenderer',
            map: { owner: 'Owner', other: 'Other', tenant: 'Tenant' },
          },
        ],
      },
    ],
    [
      {
        label: 'Permit Holder',
        data: [
          { label: 'Permit Holder Name', dataKey: 'ownerInfo.name' },
          {
            component: 'PhoneRenderer',
            label: 'Phone Number',
            dataKey: 'ownerInfo.phoneNumber',
          },
          { label: 'Email', dataKey: 'ownerInfo.emailAddress' },
          { label: 'Mailing Address', dataKey: 'ownerInfo.address' },
          {
            label: 'Owner Name on Property Title',
            dataKey: 'certificateInfo.propertyTitleName',
          },
        ],
      },
      {
        label: 'Authorized Agent',
        data: [
          { label: 'Name', dataKey: 'localContactInfo.name' },
          {
            component: 'PhoneRenderer',
            label: 'Phone Number',
            dataKey: 'localContactInfo.phoneNumber',
          },
          { label: 'Email', dataKey: 'localContactInfo.emailAddress' },
          { label: 'Mailing Address', dataKey: 'localContactInfo.address' },
          { label: 'Company Name', dataKey: 'localContactInfo.companyName' },
        ],
      },
    ],
    [
      {
        label: 'Verification Documents',
        component: 'ImageRenderer',
        type: 'file',
        fileTypes: [
          'proof_of_ownership',
          'proof_of_residence',
          'business_license',
        ],
        fileLabelMap: {
          proof_of_ownership: 'Proof of Ownership',
          proof_of_residence: 'Proof of Residence',
          business_license: 'Business License',
        },
      },
    ],
  ],
];
